module.exports = __webpack_public_path__ + "static/img/menu3-img1.475db105.png";